import { createContext } from "react";
const PearlsContext = createContext();
export default PearlsContext;

